export const styles = {
  modal: {
    position: "absolute",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    minWidth: 500,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "30px",
    p: "25px",
  },
  action: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 600,

    lineHeight: "24px",

    textAlign: "center",
    color: "#E43210",
  },
  msg: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 600,

    lineHeight: "24px",

    textAlign: "center",
    color: "#000",
  },
  btn: {
    borderRadius: "29px",
    fontWeight: 300,
  },
};
